import desktop from '@ui/menu/desktop';
import mobile from '@ui/menu/mobile';

export const init = (params) => {
    desktop.init(params);
    mobile.init(params);
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/menu/index.js